export enum EGender {
  /** 女 */
  FEMALE = 'F',
  /** 男 */
  MALE = 'M',
}
